import PropTypes from 'prop-types'
import React from 'react'

import { ResizeConsumer } from 'contexts/Resize'

import SSpyDesktopHandler from './components/SSpyDesktopHandler'
import SSpyMobileHandler from './components/SSpyMobileHandler'

/**
 * Component of SSpyHandler that you can use with SSpySection.
 *
 * @param {object} props — properties of SSpyHandler
 * @return {function} Function — KitBoxCard
 */
const SSpyHandler = props => {
  const {
    items,
    sectionsRefs,
    swiperRef,
    sceneActiveIndex,
    afterComponent,
  } = props

  return (
    <ResizeConsumer>
      {({ mobile }) =>
        mobile ? (
          <SSpyMobileHandler
            sceneActiveIndex={sceneActiveIndex}
            sectionsRefs={sectionsRefs}
            swiperRef={swiperRef}
            items={items}
          />
        ) : (
          <SSpyDesktopHandler
            afterComponent={afterComponent}
            sceneActiveIndex={sceneActiveIndex}
            sectionsRefs={sectionsRefs}
            items={items}
          />
        )
      }
    </ResizeConsumer>
  )
}

SSpyHandler.propTypes = {
  /** Items of the component */
  items: PropTypes.array.isRequired,

  /** Link to DOM node of the section*/
  sectionsRefs: PropTypes.array.isRequired,

  /** Reference on DOM node of the mobile menu */
  swiperRef: PropTypes.object.isRequired,

  /** Component that can be insert after SSpyHandler */
  afterComponent: PropTypes.object,

  /** Number of the active animation scene */
  sceneActiveIndex: PropTypes.number,
}

SSpyHandler.defaultProps = {
  sceneActiveIndex: 0,
  afterComponent: null,
}

export default SSpyHandler
